//创建动态路由

import pcLayoutViewMixins from "../mixins/pcLayoutView";
import mobileLayoutViewMixins from "../mixins/mobileLayoutView";
import enums from '../utils/enums'
let __componetMap = {
  pc: {},
  mobile: {}
};
const NOT_FOUND_EXTJS = "EXTJS未能找到";

function setMap(client, name, options) {
  __componetMap[client][name] = options;
}

function getMap(client, name) {
  return __componetMap[client][name];
}

function getComponentName(client, ns) {
  return client + "-" + ns.replace(/\./g, "-");
}
function getModuleName(client, ns) {
  let info = splitNameSpace(ns);
  let serverCreateHtmlDir = dsf.config.serverCreateHtmlDir;
  return client + "/views/" + info.ns + "/" + info.file + ".ext";
}
//切割nameSpace
function splitNameSpace(nameSpace) {
  if (nameSpace.startsWith(".")) {
    nameSpace = nameSpace.substr(1);
  }
  let arr = nameSpace.split(".");
  let fileName = arr[arr.length - 1];
  let path = arr.slice(0, arr.length).join(".");
  let ns = arr.slice(0, arr.length - 1).join(".");
  return {
    path: path,
    file: fileName,
    ns: ns
  };
}


const dynamicComponent = function (namespace, client, noCache, isRouter) {
  // let cname = getComponentName(namespace);
  client = client || "pc";
  return getRemoteComponent(namespace, noCache, isRouter);
  //动态创建组件
  function getRemoteComponent(ns, noCache, isRouter) {
    return new Promise((resolve, reject) => {
      //加载组件的js、css文件
      // let _this = this;
      if (!getMap(client, ns)) {
        getComponentTemplate(ns, noCache)
          .then((response) => {
            if (!getMap(client, ns)) {
              let moduleName = getModuleName(client, ns);
              dsf.debugTime("解析" + moduleName + "布局")
              let templateStr = response.context.tpl;
              if (client == 'mobile') {
                templateStr = "<div>" + templateStr + "</div>"
              }
              templateStr = templateStr;
              let compileFn = null;
              if (response.context.render) {
                compileFn = {
                  render: response.context.render,
                  staticRenderFns: response.context.staticRenderFns || undefined
                }
              }
              else {
                compileFn = Vue.compile(templateStr);
              }
              // debugger

              let serverCreateHtmlDir = dsf.config.serverCreateHtmlDir;
              if (dsf.isUnDef(noCache)) {
                noCache = !dsf.config.setting_public_layoutviewcache;
              }
              let cache = !noCache;
              dsf.debugTimeEnd("解析" + moduleName + "布局")
              dsf.debugTime("加载" + moduleName)
              dsf.require({
                baseUrl: serverCreateHtmlDir,
                urlArgs: (cache ? null : '_t=' + (new Date()).getTime())
              }, [moduleName], (ext) => {
                ext.mode = response?.context?.layout?.mode || enums.viewMode.DEVELOP;
                ext.pageType = response?.context?.layout?.pageType;
                ext.pageTitle = response.context.layout.title;
                ext.name = _.camelCase(getComponentName(client, ns));
                ext.needLogin = response.context.layout.needLogin === false ? false : true;
                ext.pageLevel = response.context.layout.pageLevel || 1;
                ext.isKeepAlive = response.context.layout.isKeepAlive || false;
                let mixin = client == "mobile" ? mobileLayoutViewMixins : pcLayoutViewMixins;
                ext.extends = mixin;
                ext.mixins = [];
                ext.isEs = response?.context?.layout?.isEs || false;
                ext.esIndexName = response?.context?.layout?.esIndexName || false;
                ext.waterMark = response.context.layout.waterMark === false ? false : true;
                ext.metadataDict = response?.context?.metadataDict ? dsf.mix(true, {}, response?.context?.metadataDict || {}) : null;
                ext.$$controls = response?.context?.props;
                ext.$$service = dsf.mix(true, {}, response?.context?.service || {});
                ext.$$pageDesignId = response?.context?.layout?.designId || "";
                let pt = dsf.config.layoutViewMixins[response.context.layout.pageType];
                let staticData = dsf.mix(true, {}, response?.context?.staticValue);
                //如果是其他特殊类型表单，例如问卷
                _.each(pt || [], (it) => {
                  //读取页面是否有其他混入配置
                  if (window.$mixins[it]) {
                    ext.mixins.push(window.$mixins[it]);
                  }
                });
                ext.mixins.push({
                  // template:templateStr,
                  staticRenderFns: compileFn.staticRenderFns,
                  render: compileFn.render,
                  data() {
                    let staticData = staticData
                    let controls = ext.$$controls();
                    return {
                      $$esIndexName: ext.esIndexName,
                      $$isEs: ext?.isEs,
                      $$staticValue: staticData || {},
                      $$service: ext.$$service,
                      $$controls: controls,
                      metadataDict: dsf.mix(true, {}, ext.metadataDict),
                      $$keepAlive: ext?.isKeepAlive,
                      $$pageType: ext?.pageType,
                      $$mode: ext?.mode,
                      $$pageDesignId: ext.$$pageDesignId || "",
                    };
                  },
                  computed: {
                    $isEs() {
                      return this._data.$$isEs;
                    },
                    $esIndexName() {
                      return this._data.$$esIndexName;
                    },
                    $controls() {
                      return this._data.$$controls;
                    },
                    $controlsMapping() {
                      let mapping = {};
                      for (let k in this._data.$$controls) {
                        let props = this._data.$$controls[k];
                        let hash = k.split("-")[1];
                        hash = (hash ? "-" + hash : "");
                        let key = props.caption + hash;
                        if (props.isFormControl) {
                          key = props.metadata_fullcode + hash;
                        }
                        mapping[key] = k;
                      }
                      return mapping;
                    },
                    $baseUrl: {
                      get() {
                        // return "/"
                        return this?._data?.$$service?.baseUrl || "";
                      },
                      set(v) {
                        this._data.$$service.baseUrl = v;
                      }
                    },
                    $pageComponentProps() {
                      return this._data.$$controls[this._data.$$pageDesignId];
                    }
                  },
                  created() {
                    // let pageProps = this._data.$$controls[this._data.$$pageDesignId];
                    // if (dsf.isObject(this.pageProps)) {
                    //   dsf.mix(pageProps, this.pageProps)
                    // }
                  },
                  destroyed() {
                    for (let k in this._data.$$controls) {
                      this._data.$$controls[k] = null;
                      delete this._data.$$controls[k]
                    }
                  }
                });
                setMap(client, ns, ext);
                dsf.global.Vue.component(ext.name, ext);
                dsf.debugTimeEnd("加载" + moduleName)
                resolve(ext);
                response = null;
              }, () => {
                let msg = { message: NOT_FOUND_EXTJS };
                dsf.layer.message(msg, false);
                reject(msg);
              });
            } else {
              resolve(getMap(client, ns));
            }
          })
          .catch((ex) => {
            reject(ex);
          });
      } else {
        resolve(getMap(client, ns));
      }
    });
  }

  //获取
  function getComponentTemplate(ns, noCache) {
    return new Promise((resolve, reject) => {
      // let viewinfo = splitNameSpace(ns)
      // let cacheKey = viewinfo.path + "/" + viewinfo.file;
      getLayout(ns, noCache)
        .then((response) => {
          let layoutAndStyle = getLayoutAndStyleData(response ? response.data : {});
          let props = layoutAndStyle.layout;
          let css = layoutAndStyle.css;
          props["module-name"] = ns;
          let styleEl = `<style>${css}</style>`;
          props["customCss"] = styleEl;
          let tplAndProps = dsf.designer.convertTemplateAndControlData(props);
          let code = [
            "var obj=" + JSON.stringify(tplAndProps.props) + ";",
            "return obj"
          ];
          let propsFn = new Function(code.join("\n"));
          let result = {
            context: {
              tpl: tplAndProps.tpl,
              props: propsFn,
              layout: props,
              moduleName: ns,
              metadataDict: layoutAndStyle.metadataDict || {},
              service: layoutAndStyle.service || {},
              staticValue: layoutAndStyle.staticValue || {},
              render: layoutAndStyle.render,
              staticRenderFns: layoutAndStyle.staticRenderFns
            }
          };
          resolve(result);
        })
        .catch((ex) => {
          if (dsf.type(ex) == "error") {
            let r_notfound = /40[34]+|50.+/g;
            if (r_notfound.test(ex.message)) {
              reject();
            }
          } else {
            reject(ex);
          }
        });
    });
  }

  //获取页面布局tree结构数据
  function getLayout(ns, noCache) {
    let viewinfo = splitNameSpace(ns);
    let serverCreateHtmlDir = dsf.config.serverCreateHtmlDir;
    dsf.debugTime("加载" + viewinfo.file)
    let url = serverCreateHtmlDir + client + "/views/" + viewinfo.ns + "/" + viewinfo.file + ".layout.html";
    if (dsf.isUnDef(noCache)) {
      noCache = !dsf.config.setting_public_layoutviewcache;
    }
    let cache = !noCache;
    let p = dsf.http.get(url, null,
      {
        cache,
        responseType: "text"
      }
    ).then((res) => {
      dsf.debugTimeEnd("加载" + viewinfo.file)
      return res;
    })
    return p;
  }

  //获取布局数据
  function getLayoutAndStyleData(context) {

    let dom = document.createDocumentFragment();
    let div = document.createElement("div");
    div.innerHTML = context;
    dom.appendChild(div);
    let layoutNode = div.querySelector("#layout");
    let layoutCode = ["var layout=" + (layoutNode ? layoutNode.innerHTML : "").trim() + ";", "return layout;"];
    let cssNode = div.querySelector("#css");
    let cssCode = ["var css=" + JSON.stringify((cssNode ? cssNode.innerHTML : "").trim()) + ";", "return css;"];
    let metadataNode = div.querySelector("#metadatedict");
    let metadataNodeContent = metadataNode ? metadataNode.innerHTML.trim() : "";
    let metadataCode = ["var metadatadict=" + (metadataNodeContent ? metadataNodeContent : "{}").trim() + ";", "return metadatadict;"];
    let serviceNode = div.querySelector("#service");
    let serviceCode = ["var service=" + (serviceNode ? serviceNode.innerHTML : "{}").trim() + ";", "return service;"];
    let staticValueNode = div.querySelector("#staticValue");
    let staticValueCode = ["var staticValue=" + (staticValueNode ? staticValueNode.innerHTML.trim() : "{}").trim() + ";", "return staticValue;"];
    let staticRenderFnsNode = div.querySelector("#staticRenderFns");
    let staticRenderFnsCode = ["var staticRenderFns=" + (staticRenderFnsNode ? staticRenderFnsNode.innerHTML.trim() : "null").trim() + ";", "return staticRenderFns;"];
    let renderNode = div.querySelector("#render");
    let renderCode = renderNode ? renderNode.innerHTML.trim() : ""//["var render=" + (renderNode ? renderNode.innerHTML.trim() : "null").trim() + ";", "return render;"];
    dom = null;
    div = null;


    let layoutFn = new Function(layoutCode.join("\n"));
    let cssFn = new Function(cssCode.join("\n"));
    let metadataFn = new Function(metadataCode.join("\n"));
    let layout = dsf.fillComponentDefaultProps(layoutFn());
    let css = cssFn();
    let metadataDict = metadataFn();
    let serviceFn = new Function(serviceCode.join("\n"));
    let service = serviceFn();
    let staticValueFn = new Function(staticValueCode.join("\n"));
    let staticValue = staticValueFn();
    let renderFn = null;
    let render, staticRenderFns;
    if (renderCode) {

      renderFn = new Function([renderCode].join("\n"));
      let staticRenderFnsFn = new Function(staticRenderFnsCode.join("\n"));
      render = renderFn
      staticRenderFns = staticRenderFnsFn();
      if (staticRenderFns) {
        let arr = [];
        let fns = ['var fns=[];'];
        _.each(staticRenderFns, (fnStr, i) => {
          let fn = "var fn_" + i + "=function(){";
          fn += fnStr;
          fn += "};"
          fn += "fns.push(fn_" + i + ")"
          fns.push(fn)
        })
        fns.push("return fns;")
        try {
          let sfn = new Function(fns.join("\r\n"));
          staticRenderFns = sfn();
        }
        catch (ex) {
          dsf.error(ex)
        }
      }
    }
    layoutFn = null;
    cssFn = null;
    staticValueFn = null;
    serviceFn = null;
    layoutCode.splice(0, layoutCode.length);
    layoutCode = null;
    cssCode.splice(0, cssCode.length);
    cssCode = null;
    metadataCode.splice(0, metadataCode.length);
    metadataCode = null;
    serviceCode.splice(0, serviceCode.length);
    serviceCode = null;
    staticValueCode.splice(0, staticValueCode.length);
    staticValueCode = null;
    renderCode = null;
    staticRenderFnsCode.splice(0, staticRenderFnsCode.length);

    return {
      layout,
      css,
      metadataDict,
      service,
      staticValue,
      staticRenderFns,
      render
    };
  }
}

dynamicComponent.remove = function (client, ns) {
  let name = getComponentName(client, ns);
  name = _.camelCase(name);
  //移除全局注册的组件
  delete Vue.options.components[name];
  delete __componetMap[client][ns];
  //清理掉动态加载的组件二开js
  let mname = getModuleName(client, ns);
  dsf.require.undef(mname)
}
export default dynamicComponent
